import { Link } from "react-router-dom";
import { useTheme } from "../../lib/theme";

const SRC = {
  "horizontal-light": "/logo/horizontal-light.png",
  "horizontal-dark": "/logo/horizontal-dark.png",
  "vertical-light": "/logo/vertical-light.png",
  "vertical-dark": "/logo/vertical-dark.png",
};

export const Logo = ({ light, vertical = false, className = "" }) => {
  const { dark } = useTheme();
  const onDark = light ?? dark;
  const key = `${vertical ? "vertical" : "horizontal"}-${onDark ? "dark" : "light"}`;
  return (
    <Link to="/" data-testid="site-logo" className={`flex items-center ${className}`}>
      <img src={SRC[key]} alt="Atlantis Academy" data-testid={`logo-${key}`} className={vertical ? "h-28 w-auto" : "h-11 w-auto"} />
    </Link>
  );
};
